import { useTranslation } from "react-i18next";
import type { Route } from "./+types/_index";
import { Container } from "~/components/layout/Container";
import { PageHeader } from "~/components/layout/PageHeader";
import { ServiceCategoryFilter } from "~/components/common/ServiceCategoryFilter";
import { ServiceCategoryGrid } from "~/components/service/ServiceCategoryGrid";
import {
  getItemActions,
  getServiceItemRelationships,
  getServiceItems,
} from "~/lib/api/services.server";
import { safe } from "~/lib/safe";
import { cacheHeaders } from "~/lib/cache-headers";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function loader(_args: Route.LoaderArgs) {
  const [items, relationships, actions] = await Promise.all([
    safe(() => getServiceItems(), []),
    safe(() => getServiceItemRelationships(), []),
    safe(() => getItemActions(), []),
  ]);
  return { items, relationships, actions };
}

export const headers = () => cacheHeaders["public-300"];

export const meta: Route.MetaFunction = () => [
  { title: "Services | Raytio Trust Marketplace" },
  {
    name: "description",
    content: "Browse services by category on the Raytio Trust Marketplace.",
  },
];

export default function ServicesRoute({ loaderData }: Route.ComponentProps) {
  const { items, relationships, actions } = loaderData;
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        eyebrow={t("ServicesPage.eyebrow")}
        title={t("ServicesPage.title")}
        subtitle={t("ServicesPage.subtitle")}
      />
      <section className="py-12">
        <Container>
          <div className="max-w-xl">
            <ServiceCategoryFilter
              items={items}
              relationships={relationships}
            />
          </div>

          <ServiceCategoryGrid
            items={items}
            relationships={relationships}
            actions={actions}
          />
        </Container>
      </section>
    </>
  );
}
